if (!customElements.get("trust-section-splide")) {
  customElements.define(
    "trust-section-splide",
    class TrustSectionSplide extends HTMLElement {
      constructor() {
        super();
        this.splide = null;
      }

      connectedCallback() {
        this.initSlider();
        this.initMuteButtons();
      }

      initSlider() {
        const splideElement = this.querySelector('.splide');
        if (!splideElement || typeof window.Splide === "undefined") return;

        this.splide = new window.Splide(splideElement, {
          type: 'loop',
          autoplay: false,
          perPage: 4,
          gap: '20px',
          perMove: 1,
          focus: 'center',
          pagination: false,
          breakpoints: {
            767: {
              perPage: 1.5,
              fixedWidth: '90%',
              trimSpace: false,
              focus: 0
            },
            989: {
              perPage: 2.5
            },
            1199: {
              gap: '16px'
            }
          }
        });

        this.splide.on('moved', () => {
          queueMicrotask(() => {
            this.handleSlideChange();
          })
        });

        this.splide.mount();

        queueMicrotask(() => {
          this.handleSlideChange();
        })
      }

      initMuteButtons() {
        const muteButtons = this.querySelectorAll('.trust-card-mute-button');
        muteButtons.forEach(button => {
          button.addEventListener('click', (e) => this.toggleMute(e));
        });
      }

      toggleMute(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const button = event.currentTarget;
        const trustCard = button.closest('.trust-card');
        const video = trustCard.querySelector('video');
        
        if (!video) return;
        
        const isMuted = !button.classList.contains('unmuted');
        
        if (isMuted) {
          video.muted = false;
          button.classList.add('unmuted');
          button.setAttribute('aria-label', 'Mute video');
        } else {
          video.muted = true;
          button.classList.remove('unmuted');
          button.setAttribute('aria-label', 'Unmute video');
        }
      }

      handleSlideChange() {
        const allVideos = this.querySelectorAll('video');
        allVideos.forEach(video => {
          video.pause();
        });

        try {
          if (this.querySelector('.splide__slide.is-active.is-visible')) {
            const currentSlide = this.querySelector('.splide__slide.is-active.is-visible');
            const currentVideo = currentSlide.querySelector('video');
            if (currentVideo) {
              currentVideo.play().catch(e => {
                console.error('Video autoplay failed:', e);
              });
            }
          }
        } catch (error) {
          console.error('Error handling slide change:', error);
        }
      }

      disconnectedCallback() {
        if (this.splide) {
          this.splide.destroy();
        }
      }
    }
  );
}
